import React from 'react';
import { FormBuilder } from 'commons-ui';
import useAdd from './useAdd';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG_ADD, addValidationSchema } from '../../utils/formConfig';

const AddInternalUser: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useAdd();

	return (
		<FormBuilder
			data={data}
			mode='add'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={addValidationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG_ADD}
			dependencies={[]}
		/>
	);
};

export default AddInternalUser;
